import { render, staticRenderFns } from "./MunicipalityLogo.vue?vue&type=template&id=be7c2620&scoped=true&"
import script from "./MunicipalityLogo.vue?vue&type=script&lang=ts&"
export * from "./MunicipalityLogo.vue?vue&type=script&lang=ts&"
import style0 from "./MunicipalityLogo.vue?vue&type=style&index=0&id=be7c2620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7c2620",
  null
  
)

export default component.exports